import demo_uat from "./demo_uat.js"
export default demo_uat
